export class Sheet {
  grade: number = 0
  name: string = ""
  curriculum_id: number = 0
  subject_name: string
  subject_code: string
  sheet_type: number

  constructor(sheet: any){
    this.grade = sheet.grade;
    this.name = sheet.name;
    this.curriculum_id = sheet.curriculum_id;
    this.subject_name = sheet.subject_name;
    this.subject_code = sheet.subject_code;
    this.sheet_type = sheet.sheet_type;
  }
}

export class SumupSheet {
  room_name: number
  student_count: number
  allot: number
  min_score: number
  max_score: number
  score_average: number
  score_rate: number

  constructor(sumupSheet: any){
    this.room_name = sumupSheet.room_name;
    this.student_count = sumupSheet.student_count;
    this.allot = sumupSheet.allot;
    this.min_score = sumupSheet.min_score;
    this.max_score = sumupSheet.max_score;
    this.score_average = sumupSheet.score_average;
    this.score_rate = sumupSheet.score_rate;
  }
}